import { useTranslation } from 'react-i18next';

import st from './SelectedEventEmptyState.module.sass';

export function SelectedEventEmptyState(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={st.NoSelectedEventDummy}>
      <div className={st.DummyText}>{t('lunapoint:operator_panel.select_event')}</div>
      <div className={st.DummyPicture} />
    </div>
  );
}
